import { VouchStatus } from '../../../types/schema';
import { SVGIcon } from '../../svg-icon';
import { colorAmber, colorCrimson, colorDarkGreen } from '../../../theme/color';
import { style } from 'typestyle';
import { px } from 'csx';
import React from 'react';

export interface VouchStatusDisplayProps {
  status: VouchStatus;
  className: string;
}

const styles = {
  text: style({ marginLeft: px(10), marginRight: px(10) }),
};

export class VouchStatusDisplay extends React.Component<VouchStatusDisplayProps> {
  render() {
    const { status, className } = this.props;

    if (status === 'CLEARED') {
      return (
        <span className={className}>
          <SVGIcon.Checkmark color={colorDarkGreen.toHexString()} size={16} />
          <span className={styles.text}>VOUCH integrated</span>
        </span>
      );
    }
    /* When we generate a licence we have a separate clause for OVERRIDDEN status, but it's misleading
    if (status === 'OVERRIDDEN') {
      return (
        <span className={className}>
          <SVGIcon.Checkmark color={colorAmber.toHexString()} size={16} />
          <strong className={styles.text}>VOUCH INTEGRATED</strong>
        </span>
      );
    }*/
    return (
      <span className={className}>
        <SVGIcon.Cross color={colorCrimson.toHexString()} size={16} />
        <strong className={styles.text}>NOT VOUCH INTEGRATED</strong>
      </span>
    );
  }
}
